var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#325880"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 27.75C16.25 28.5784 15.5784 29.25 14.75 29.25C13.9216 29.25 13.25 28.5784 13.25 27.75M16.25 27.75C16.25 26.9216 15.5784 26.25 14.75 26.25C13.9216 26.25 13.25 26.9216 13.25 27.75M16.25 27.75H22.25M13.25 27.75H11.375C10.7537 27.75 10.25 27.2463 10.25 26.625V23.2504M27.5 27.75C27.5 28.5784 26.8284 29.25 26 29.25C25.1716 29.25 24.5 28.5784 24.5 27.75M27.5 27.75C27.5 26.9216 26.8284 26.25 26 26.25C25.1716 26.25 24.5 26.9216 24.5 27.75M27.5 27.75L28.625 27.75C29.2463 27.75 29.7537 27.2457 29.7154 26.6256C29.5054 23.218 28.3473 20.0669 26.5016 17.4328C26.1394 16.9159 25.5529 16.6077 24.9227 16.5732H22.25M24.5 27.75H22.25M22.25 16.5732V15.6148C22.25 15.0473 21.8275 14.5672 21.263 14.5086C19.6153 14.3376 17.9429 14.25 16.25 14.25C14.5571 14.25 12.8847 14.3376 11.237 14.5086C10.6725 14.5672 10.25 15.0473 10.25 15.6148V23.2504M22.25 16.5732V23.2504M22.25 27.75V23.2504M22.25 23.2504H10.25",
    stroke: "#FFDE30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationTruck);
export default __webpack_public_path__ + "static/media/notification-truck.dd13b7bc4660b42a90e23f483de90120.svg";
export { ForwardRef as ReactComponent };